export function arrayFirst(arr) {
    return arr?.[0];
}

export function arrayLast(arr) {
    return arr && arr.length > 0 ? arr[arr.length - 1] : null;
}